module.exports = __webpack_public_path__ + "static/media/nyan_cat.d93d55cd.gif";